export default "__VITE_ASSET__526c1812__"